<template>
    <div class="text-center">
        <div class="text-dark">Powered by</div>

        <app-logo theme="dark" class="mt-6 max-w-xs mx-auto"></app-logo>

        <div class="text-dark mt-6">&copy; {{ currentYear }}</div>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import AppLogo from '@/Components/AppLogo.vue';

export default {
    components: {
        AppLogo
    },
    computed: {
        currentYear() {
            return dayjs().format('YYYY');
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
